import { css } from "@emotion/react";
import styled from "@emotion/styled";
// eslint-disable-next-line import/no-cycle
import SubscribeBox from "../components/SubscribeBox";
import { GeneralBox } from "./component";
import Input from "@/components/Input";
import Button from "@/components/Button";

export const GeneralBoxWrapper = styled.div`
	width: 100%;
	border-radius: 4px;
	padding: 30px 0 30px 30px;
	border: 1px solid #e0e0e0;
	display: flex;
	align-items: flex-start;
`;

export const GeneralBoxTitle = styled.p`
	width: 300px;
	line-height: 24px;
	color: #0d0d0d;
	font-weight: bold;
`;

export const GeneralBoxContent = styled.div`
	width: 0;
	flex-grow: 1;
	height: 100%;
`;

export const WebcomePlanGuideWrapper = styled.div`
	display: flex;
	gap: 0.6rem;
	border-radius: 0.25rem;
	background-color: #fff4db;
	padding: 1.25rem 2.3rem;
	font-size: 0.875rem;
	line-height: 1.375rem;
`;

export const OrganizationSubscribeBox = styled(SubscribeBox)`
	margin-bottom: 40px;
`;

export const OrganizationWrapper = styled.div`
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	width: 100%;
`;

const OrganizationGeneralBox = css`
	padding-right: 34px;
`;

export const OrganizationNameGeneralBox = styled(GeneralBox)`
	${OrganizationGeneralBox}
	border-bottom-width: 1px;
	border-radius: 4px 4px 0 0;
`;

export const OrganizationInput = styled(Input)`
	width: 100%;
	padding: 4px 20px;
	border-radius: 4px;
	font-size: 14px;
`;

export const OrganizationApiGeneralBox = styled(GeneralBox)`
	${OrganizationGeneralBox}
	border-top-width: 0;
	border-radius: 0 0 4px 4px;
`;

export const AppListWrapper = styled.div`
	border: solid 1px #e0e0e0;
	border-radius: 4px;
	margin-top: 1.5rem;
`;

export const AppTitleWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	border-bottom: solid 1px #e0e0e0;
	padding: 1.75rem;
`;

export const AppTitleNameWrapper = styled.div`
	display: flex;
	gap: 0.7rem;
	align-items: center;
`;

export const AppTitleName = styled.div`
	font-size: 1.25rem;
`;

export const AppPaymentChangeButton = styled(Button)`
	// width: 5.625rem;
	height: 2.5rem;
`;

export const AppDetailWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-row-gap: 0.8rem;
	padding: 1.75rem;
`;

export const AppDetailContents = styled.div`
	display: flex;
	gap: 3.5rem;
`;

export const AppDetailTitle = styled.div<{ width: string }>`
	width: ${(props) => props.width};
	font-size: 1rem;
	color: #545351;
`;

export const DescriptionUpperTitleImage = styled.div`
	margin-right: 10px;
	width: 34px;
	height: 34px;
	padding: 5px;
	border-radius: 4px;
	background-color: #5292fa;
	display: flex;
	align-items: center;
	justify-content: center;
`;
